module.exports = __webpack_public_path__ + "img/go2-course.c7242846.png";